import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { userShape } from 'constants/propTypes';
import { dateIsWithin24Hours } from 'utils/dates';

import buildNextUrl from 'utils/buildNextUrl';
import { loginWithNextUrl } from 'utils/auth';
import { changePasswordPathUri } from './ProtectedRoute.constants';

const ProtectedRoute = ({ user, component: Component, exact, path }) => (
  <Route
    exact={exact}
    path={path}
    render={({ history, match, location }) => {
      if (!user) {
        const nextUrl = buildNextUrl(location);

        return loginWithNextUrl(nextUrl);
      }

      const shouldChangePassword = location.pathname !== changePasswordPathUri && dateIsWithin24Hours(user.passwordExpiry);

      return shouldChangePassword ? (
        <Redirect to={{ pathname: changePasswordPathUri }} />
      ) : (
        <Component user={user} history={history} match={match} location={location} />
      );
    }}
  />
);

ProtectedRoute.propTypes = {
  ...Route.propTypes,
  user: userShape
};

export default ProtectedRoute;
